import { ActivityPart } from '@/api/models/activityParts'
import { ActivityWithAggregate } from '@/api/models/aggregate'

export const checkBeforeStartFrom = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.startFrom) {
    return false
  }

  const startFrom = new Date(constraint.startFrom)
  const now = new Date()
  return now < startFrom
}

export const checkAfterStartUntil = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.startUntil) {
    return false
  }

  const startUntil = new Date(constraint.startUntil)
  const now = new Date()
  return now > startUntil
}

export const checkAfterAccessibleUntil = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.accessibleUntil) {
    return false
  }

  const accessibleUntil = new Date(constraint.accessibleUntil)
  const now = new Date()
  return now > accessibleUntil
}

export const checkAfterGracePeriodUntil = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.gracePeriodUntil) {
    return false
  }

  const gracePeriodUntil = new Date(constraint.gracePeriodUntil)
  const now = new Date()
  return now > gracePeriodUntil
}

export const checkAfterDueDate = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.due) {
    return false
  }

  const due = new Date(constraint.due)
  const now = new Date()
  return now > due
}

export const checkAfterRevealingDate = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const constraint = activityPart?.activityConstraint

  if (!constraint || !constraint.resultsDisclosureFrom) {
    return true
  }

  const from = new Date(constraint.resultsDisclosureFrom)
  const now = new Date()
  return now > from
}
